// TurnoModal.jsx
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import baseURL from '../url';
import "./TurnoModal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faUser, faCalendarAlt, faTimesCircle, faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
// Importar el ícono de historial de react-icons
import { AiOutlineHistory } from 'react-icons/ai';
import { FaUser, FaPhone, FaBuilding, FaBook, FaUserMd, FaDoorOpen, FaInfoCircle, FaEdit, FaSave, FaClock, FaComment, FaCalendarAlt } from 'react-icons/fa';
// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español

const TAB_LIST = [
  { key: 'perfil', label: 'Perfil', icon: faUser, type: 'fa' },
  { key: 'citas', label: 'Citas', icon: faCalendarAlt, type: 'fa' },
  { key: 'historial', label: 'Historial', icon: AiOutlineHistory, type: 'react' },
  { key: 'comentarios', label: 'Comentarios', icon: faComment, type: 'fa' },
  { key: 'cancelar', label: 'Cancelar', icon: faTimesCircle, type: 'fa' },
];

const TurnoModal = ({
  isOpen,
  onClose,
  turnoSeleccionado,
  nombre,
  setNombre,
  telefono,
  setTelefono,
  motivoInactivo,
  setMotivoInactivo,
  nuevaFecha,
  setNuevaFecha,
  periodicidad,
  setPeriodicidad,
  nuevaHoraInicio,
  setNuevaHoraInicio,
  nuevaHoraFin,
  setNuevaHoraFin,
  nuevoComentario,
  setNuevoComentario,
  comentarioActualizado,
  cancelarActualizado,
  nuevoEstado,
  setNuevoEstado,
  categorias,
  categoriaSeleccionada,
  setCategoriaSeleccionada,
  servicioSeleccionado,
  setServicioSeleccionado,
  terapeutaSeleccionado,
  setTerapeutaSeleccionado,
  salaSeleccionada,
  setSalaSeleccionada,
  citasSeleccionadas,
  setCitasSeleccionadas,
  alertAsignarSala,
  handleUpdateText,
  handleUpdateDate,
  handleInsertComment,
  handleCancelar
}) => {

  const [salas, setSalas] = useState([]);
  const [salasDisponibles, setSalasDisponibles] = useState([]);
  const [listaTerapeutas, setListaTerapeutas] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [catalogoMotivosInactivo, setCatalogoMotivosInactivo] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [citasProgramadas, setCitasProgramadas] = useState([]);
  const [citasHistorial, setCitasHistorial] = useState([]);

  const [tab, setTab] = useState('perfil');
  const [btnEstado, setBtnEstado] = useState();
  const [btnFecha, setBtnFecha] = useState();

  const [nombreCategoria, setNombreCategoria] = useState();
  const [nombreServicio, setNombreServicio] = useState();
  const [nombreTerapeuta, setNombreTerapeuta] = useState();
  const [estado, setEstado] = useState();

  const horas = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00"];

  const [selecciones, setSelecciones] = useState();

  const isDisabled = citasSeleccionadas.length === 0;

  const obtenerServicios = async () => {

    setServicios([]);

    try {

      fetch(`${baseURL}/serviciosCategoriaGet.php?idTienda=${categoriaSeleccionada}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar CESECOS',
              text: data.error,
            });
          } else {
            setServicios(data.servicios || []);
          }

        })
        .catch(error => console.error('Error al cargar programas:', error));


    } catch (error) {
      console.error('Error al obtener los progamas disponibles:', error);
    }

  };

  const cargarTerapeutas = async () => {

    setListaTerapeutas([]);

    try {
      fetch(`${baseURL}/terapeutasPorPrograma.php?idServicio=${servicioSeleccionado}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {

          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar terapeutas',
              text: data.error,
            });
          } else {
            setListaTerapeutas(data || []);
          }

        })
        .catch(error => console.error('Error al cargar terapeutas:', error));

    } catch (error) {
      console.error('Error al obtener terapeutas:', error);
    }


  };

  const obtenerComentarios = async () => {

    setComentarios([]);
    
    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/comentariosGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar comentarios',
                text: data.error,
              });
            } else {
              setComentarios(data.comentarios);
            }

          })
          .catch(error => console.error('Error al cargar comentarios:', error));

      } catch (error) {
        console.error('Error al obtener comentarios:', error);
      }
    }

  };

  const obtenerCitasProgramadas = async () => {

    setCitasProgramadas([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/turnosPorPacienteGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar las citas programadas',
                text: data.error,
              });
            } else {
              const citasConDiasParseado = data.turnos.map((cita) => ({
                ...cita,
                dias: JSON.parse(cita.dias)
              }));
              setCitasProgramadas(citasConDiasParseado);
            }

          })
          .catch(error => console.error('Error al cargar las citas programadas:', error));

      } catch (error) {
        console.error('Error al obtener las citas programadas:', error);
      }
    }
  };

  const obtenerCitasHistorial = async () => {

    setCitasHistorial([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/turnosHistorialGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar historial de citas',
                text: data.error,
              });
            } else {
              const citasConDiasParseado = data.turnos.map((cita) => ({
                ...cita,
                dias: JSON.parse(cita.dias)
              }));
              setCitasHistorial(citasConDiasParseado);
            }

          })
          .catch(error => console.error('Error al cargar historial de citas:', error));

      } catch (error) {
        console.error('Error al obtener historial de citas:', error);
      }
    }
  };

  const obtenerSalasDisponibles = async () => {

    setSalas([]);
    setSalasDisponibles([]);

    if (turnoSeleccionado && categoriaSeleccionada > 0 && turnoSeleccionado.dias && turnoSeleccionado.dias.length > 0 && terapeutaSeleccionado) {
      try {
        const { dia, horaInicio, horaFin } = turnoSeleccionado.dias[0];

        fetch(`${baseURL}/salasDisponiblesGet.php?fecha=${dia}&horaInicio=${horaInicio}&horaFin=${horaFin}&idCategoria=${categoriaSeleccionada}&idTerapeuta=${terapeutaSeleccionado}&idTurno=${turnoSeleccionado.idTurno}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              if (turnoSeleccionado.estado != 'Asignado') {
                Swal.fire({
                  icon: 'warning',
                  title: '',
                  text: data.error,
                });
              }
            } else {
              setSalas(data.salas || []);
              setSalasDisponibles(data.salasDisponibles || []);

            }

          })
          .catch(error => console.error('Error al cargar salas disponibles:', error));


      } catch (error) {
        console.error('Error al obtener las salas disponibles:', error);
      }
    }
  };

  const cargarCatalogos = () => {
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=motivos_inactivo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosInactivo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos_inactivo:', error));

  };

  const checkDatosCompletos = () => {
    if (nombre == '' || nombre == null) {
      Swal.fire('Atención!', 'Debes escribir el nombre del paciente', 'alert');
    } else if (telefono == '' || telefono == null) {
      Swal.fire('Atención!', 'Debes escribir el teléfono del paciente', 'alert');
    } else if (servicioSeleccionado == null || servicioSeleccionado == '') {
      Swal.fire('Atención!', 'Debes seleccionar un programa', 'alert');
    } else if (nuevoEstado == 'Asignado' && (terapeutaSeleccionado == null || terapeutaSeleccionado == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un terapeuta', 'alert');
    } else if (nuevoEstado == 'Asignado' && (salaSeleccionada == null || salaSeleccionada == '')) {
      Swal.fire('Atención!', 'Debes seleccionar una sala', 'alert');
    } else if ((nuevoEstado == 'Inactivo' || nuevoEstado == 'Finalizado') && (motivoInactivo == null || motivoInactivo == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un motivo', 'alert');
    } else {
      setBtnEstado('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateText(turnoSeleccionado.idTurno);

    }
  }

  const checkComentarioCompleto = (tipo) => {
    if (nuevoComentario == '' || nuevoComentario == null) {
      Swal.fire('Atención!', 'Debes escribir un comentario', 'alert');
    } else {
      handleInsertComment(turnoSeleccionado.idTurno, tipo);
    }
  }

  const checkDatosPrograma = () => {

    if (nuevaFecha == '' || nuevaFecha == null) {
      Swal.fire('Atención!', 'Debes seleccionar una fecha', 'alert');
    } else if (periodicidad == '' || periodicidad == null) {
      Swal.fire('Atención!', 'Debes seleccionar la periodicidad', 'alert');
    } else {
      setBtnFecha('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateDate(turnoSeleccionado.idTurno);
    }
  }

  const handleAgregarUnaCita = async () => {
    // Calcular la próxima cita a agendar
    let fechaBase = nuevaFecha;
    if (citasProgramadas.length > 0) {
      // Tomar la última cita futura
      const ultCita = citasProgramadas[citasProgramadas.length - 1];
      fechaBase = ultCita.dias[0].dia;
    }
    // Calcular la siguiente fecha según periodicidad
    let siguienteFecha = moment(fechaBase);
    if (periodicidad === 'Semanal') {
      siguienteFecha = siguienteFecha.add(7, 'days');
    } else if (periodicidad === 'Quincenal') {
      siguienteFecha = siguienteFecha.add(14, 'days');
    }
    const diaSemana = siguienteFecha.format('dddd');
    const fechaStr = siguienteFecha.format('D [de] MMMM [de] YYYY');
    const horaInicio = nuevaHoraInicio;
    const horaFin = nuevaHoraFin;
    // Mostrar confirmación
    const result = await Swal.fire({
      title: '¿Agregar una nueva cita?',
      html: `<b>Fecha:</b> ${fechaStr}<br/><b>Día:</b> ${diaSemana}<br/><b>Hora:</b> ${horaInicio} - ${horaFin}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agendar',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      setNuevoComentario("");
      await handleInsertComment(turnoSeleccionado.idTurno, 4);
      await obtenerCitasProgramadas();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setNombre(turnoSeleccionado?.nombre || '');
      setTelefono(turnoSeleccionado?.telefono || '');

      setCategoriaSeleccionada(turnoSeleccionado?.idCategoriaSala || '');
      setServicioSeleccionado(turnoSeleccionado?.idServicio || '');
      setTerapeutaSeleccionado(turnoSeleccionado?.idTerapeuta || '');
      setSalaSeleccionada(turnoSeleccionado?.idSala || '');

      setNuevaFecha(turnoSeleccionado.dias[0].dia);
      setPeriodicidad(turnoSeleccionado.periodicidad);
      setNuevaHoraInicio(turnoSeleccionado.dias[0].horaInicio);
      setNuevaHoraFin(turnoSeleccionado.dias[0].horaFin);

      setNuevoEstado(turnoSeleccionado?.estado || '');

      setNombreCategoria(turnoSeleccionado?.nombreCategoria || '');
      setNombreServicio(turnoSeleccionado?.servicio || '');
      setNombreTerapeuta(turnoSeleccionado?.nombreTerapeuta || '');
      setEstado(turnoSeleccionado?.estado || '');

      setBtnEstado('Editar');
      setBtnFecha('Editar')
      setTab('perfil');
      setSelecciones({ todas: false });
      setCitasSeleccionadas([]);

      setNuevoComentario("");

      cargarCatalogos();
      obtenerComentarios();
      obtenerCitasProgramadas();
      obtenerCitasHistorial();

    }

  }, [isOpen, turnoSeleccionado]);


  useEffect(() => {
    if (!isOpen) return;
    obtenerServicios();

  }, [isOpen, categoriaSeleccionada]);

  const handleCategoriaSeleccionada = (e) => {
    setCategoriaSeleccionada(e.target.value)
    setServicioSeleccionado(null);
    obtenerServicios();
  }

  useEffect(() => {
    if (!isOpen) return;
    cargarTerapeutas();
  }, [isOpen, servicioSeleccionado]);

  const handleServicioSeleccionado = (e) => {
    setServicioSeleccionado(e.target.value)
    setTerapeutaSeleccionado(null);
    cargarTerapeutas();
  }

  useEffect(() => {
    if (!isOpen) return;
    obtenerSalasDisponibles();
  }, [isOpen, terapeutaSeleccionado]);

  useEffect(() => {
    if (isOpen) {
      obtenerComentarios();
    }
  }, [comentarioActualizado]);

  useEffect(() => {
    if (isOpen) {
      obtenerCitasProgramadas();
    }
  }, [cancelarActualizado]);


  const handleTerapeutaSeleccionado = (e) => {
    setTerapeutaSeleccionado(e.target.value)
    setSalaSeleccionada(null);
    obtenerSalasDisponibles();
  }


  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (value === "todas") {

      const todosIds = citasProgramadas.map(cita => cita.idTurno);
      setCitasSeleccionadas(todosIds);
      setSelecciones({ todas: checked });
    } else {

      const idCita = Number(value);
      let nuevasCitas = [...citasSeleccionadas];
      if (checked) {
        nuevasCitas.push(idCita);
      } else {
        nuevasCitas = nuevasCitas.filter((id) => id !== idCita);
      }

      setCitasSeleccionadas(nuevasCitas);
      setSelecciones({ todas: false });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Detalle de la cita"
      ariaHideApp={false}
      className="modal-admin"
      overlayClassName="overlay-admin"
    >
      {/* HEADER */}
      <div className='deFlexBtnsModal'>
        <div className='deFlexBtnsModal'>
          <div className="patientPhoto" />
          <div className="patientData">
            <h4>{turnoSeleccionado.nombre}</h4>
            <span>ID: {turnoSeleccionado.idTurno}</span>
          </div>
          <div className="bookStatus">
            <span>Estatus del paciente:</span>
            <span className="status">{estado}</span>
            <span className="motivo-inactivo">{turnoSeleccionado.motivo_inactivo}</span>
          </div>
        </div>
        <span className="close" onClick={onClose}>&times;</span>
      </div>

      {/* TABS SUPERIORES */}
      <div className="tabs">
        {TAB_LIST.map(tabItem => (
          <button
            key={tabItem.key}
            className={`tab-label${tab === tabItem.key ? ' active' : ''}`}
            onClick={() => setTab(tabItem.key)}
          >
            {tabItem.type === 'fa' ? (
              <FontAwesomeIcon icon={tabItem.icon} style={{ marginRight: 8 }} />
            ) : (
              <tabItem.icon style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />
            )}
            {tabItem.label}
          </button>
        ))}
      </div>

      {/* CONTENIDO DE TABS */}
      <div className="tab-content">
        {/* PERFIL */}
        {tab === 'perfil' && (
          <div className="profile-card">
            {btnEstado === 'Editar' ? (
              <>
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-value">{nombre}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-value">{telefono}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-value">{nombreCategoria}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-value">{nombreServicio}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Terapeuta *</span>
                    <span className="profile-value">{nombreTerapeuta}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-value">{salaSeleccionada ? salas.find(s => s.idSala == salaSeleccionada)?.nombre : ''}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaInfoCircle className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Estado *</span>
                    <span className="profile-value">{estado}</span>
                  </div>
                </div>
                {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Motivo *</span>
                      <span className="profile-value">{motivoInactivo}</span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-input-icon"><FaUser /></span>
                    <input className="profile-input" type="text" value={nombre} onChange={e => setNombre(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-input-icon"><FaPhone /></span>
                    <input className="profile-input" type="text" value={telefono} onChange={e => setTelefono(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-input-icon"><FaBuilding /></span>
                    <select
                      className="profile-select"
                      value={categoriaSeleccionada || ""}
                      onChange={handleCategoriaSeleccionada}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar CESECO</option>
                      {categorias.map(c => (
                        <option key={c.idCategoria} value={c.idCategoria}>
                          {c.categoria}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-input-icon"><FaBook /></span>
                    <select
                      className="profile-select"
                      value={servicioSeleccionado || ""}
                      onChange={handleServicioSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar Programa</option>
                      {servicios.map(s => (
                        <option key={s.idServicio} value={s.idServicio}>
                          {s.titulo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Asignar a *</span>
                    <span className="profile-input-icon"><FaUserMd /></span>
                    <select
                      className="profile-select"
                      value={terapeutaSeleccionado || ""}
                      onChange={handleTerapeutaSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar usuario</option>
                      {listaTerapeutas.map(t => {
                        const rolLabel = t.rol === 'terapeuta' ? 'Terapeuta' :
                                        t.rol === 'coord_programa' ? 'Coord. Programa' :
                                        t.rol === 'coord_ceseco' ? 'Coord. CESECO' : t.rol;
                        return (
                          <option key={t.idUsuario} value={t.idUsuario}>
                            {t.nombre} ({rolLabel})
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-input-icon"><FaDoorOpen /></span>
                    <select
                      className="profile-select"
                      value={salaSeleccionada || ""}
                      onChange={e => setSalaSeleccionada(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccione una sala</option>
                      {salas.map((s) => {
                        const estaDisponible = salasDisponibles.some(sd => sd.idSala === s.idSala);
                        return (
                          <option
                            key={s.idSala}
                            value={s.idSala}
                            disabled={!estaDisponible}
                          >
                            {s.nombre} {estaDisponible ? '' : '(No disponible)'}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaInfoCircle className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Estado *</span>
                    <span className="profile-input-icon"><FaInfoCircle /></span>
                    <select
                      className="profile-select"
                      value={nuevoEstado || ""}
                      onChange={e => setNuevoEstado(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="Pendiente">Pendiente</option>
                      <option value="Asignado">Asignado</option>
                      <option value="Finalizado">Finalizado</option>
                      <option value="Inactivo">Inactivo</option>
                    </select>
                  </div>
                </div>
                {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span className="profile-label">Motivo *</span>
                      <span className="profile-input-icon"><FaInfoCircle /></span>
                      <select
                        className="profile-select"
                        value={motivoInactivo || ""}
                        onChange={e => setMotivoInactivo(e.target.options[e.target.selectedIndex].text)}
                        required
                        style={{ paddingLeft: 38 }}
                      >
                        <option value="" disabled>Seleccione un motivo</option>
                        {catalogoMotivosInactivo.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="profile-save-btn-container">
              <button className="profile-edit-btn" onClick={() => {
                if (btnEstado === 'Editar') {
                  setBtnEstado('Guardar');
                } else {
                  checkDatosCompletos();
                }
              }}>
                {btnEstado === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                {btnEstado === 'Editar' ? 'Editar' : 'Guardar'}
              </button>
            </div>
          </div>
        )}

        {/* CITAS */}
        {tab === 'citas' && (
          <div className="card-section citas-modern">
            <div className="citas-header-row">
              <div className="citas-header-title">
                <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8, fontSize: 22 }} />
                <span style={{ fontWeight: 700, fontSize: 18 }}>Próxima cita</span>
              </div>
              <button className="section-edit-btn" onClick={() => {
                if (btnFecha === 'Editar') {
                  setBtnFecha('Guardar');
                } else {
                  checkDatosPrograma();
                }
              }}>
                {btnFecha === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                {btnFecha === 'Editar' ? 'Editar' : 'Guardar'}
              </button>
            </div>
            <div className="citas-fields-row">
              {btnFecha === 'Editar' ? (
                <>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                    <div>
                      <div className="cita-label">Fecha</div>
                      <div className="cita-value">{moment(turnoSeleccionado.dias[0].dia).format('dddd D [de] MMMM [de] YYYY')}</div>
                    </div>
                  </div>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faClock} className="cita-icon" />
                    <div>
                      <div className="cita-label">Hora</div>
                      <div className="cita-value">{turnoSeleccionado.dias[0].horaInicio} - {turnoSeleccionado.dias[0].horaFin}</div>
                    </div>
                  </div>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                    <div>
                      <div className="cita-label">Periodicidad</div>
                      <div className="cita-value">{periodicidad}</div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                    <div>
                      <div className="cita-label">Fecha</div>
                      <input type="date" value={nuevaFecha} onChange={e => setNuevaFecha(e.target.value)} className="cita-input" />
                    </div>
                  </div>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faClock} className="cita-icon" />
                    <div>
                      <div className="cita-label">Hora inicio</div>
                      <input type="time" value={nuevaHoraInicio} onChange={e => setNuevaHoraInicio(e.target.value)} className="cita-input" />
                      <div className="cita-label" style={{ marginTop: 8 }}>Hora fin</div>
                      <input type="time" value={nuevaHoraFin} onChange={e => setNuevaHoraFin(e.target.value)} className="cita-input" />
                    </div>
                  </div>
                  <div className="cita-field-card">
                    <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                    <div>
                      <div className="cita-label">Periodicidad</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <select value={periodicidad} onChange={e => setPeriodicidad(e.target.value)} className="cita-input">
                          <option value="">Seleccione</option>
                          <option value="Semanal">Semanal</option>
                          <option value="Quincenal">Quincenal</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <button
              className="btnBlue cita-add-btn"
              onClick={handleAgregarUnaCita}
              disabled={citasProgramadas.length >= 4}
            >
              <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: 8 }} />
              Agregar una cita
            </button>
            <div className="citas-futuras-list">
              <div className="citas-futuras-title">
                <FontAwesomeIcon icon={faListAlt} className="cita-icon" />
                <b>Citas futuras:</b> (Maximo 4 citas programadas)
              </div>
              {citasProgramadas && citasProgramadas.length > 0 ? (
                <ul className="citas-futuras-ul">
                  {citasProgramadas.map((cita, idx) => {
                    const fechaMoment = moment(cita.dias[0].dia);
                    const diaSemana = fechaMoment.format('dddd');
                    const fechaFormateada = fechaMoment.format('D [de] MMMM [de] YYYY');
                    return (
                      <li key={cita.idTurno} className="citas-futuras-li">
                        <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon-sm" />
                        <span className="cita-futura-text">{diaSemana} {fechaFormateada} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <div className="citas-futuras-empty">No hay citas futuras programadas.</div>
              )}
            </div>
          </div>
        )}

        {/* HISTORIAL */}
        {tab === 'historial' && (
          <div className="card-section">
            <div className="timeline">
              {citasHistorial.map((cita, i) => {
                const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                const diaSemana = diasSemana[fecha.getDay()];
                return (
                  <div className="timeline-event" key={cita.idTurno}>
                    <div className="timeline-dot" />
                    <div className="timeline-content">
                      <div><b>Sesión {i + 1}</b>: {diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</div>
                      <div><b>Estatus:</b> {cita.estado}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* COMENTARIOS */}
        {tab === 'comentarios' && (
          <>
            <div className="card-section comentarios-add-card">
              <fieldset className="comentarios-add-fieldset">
                <textarea
                  placeholder="Agregar comentario.."
                  value={nuevoComentario}
                  onChange={e => setNuevoComentario(e.target.value)}
                  id="comentario"
                  rows={3}
                  className="comentarios-add-textarea"
                />
              </fieldset>
              <div className="comentarios-btns-row">
                <button className="btnGrey" onClick={() => checkComentarioCompleto(1)}>
                  Guardar sólo el comentario
                </button>
                <button className="btnGreen" onClick={() => checkComentarioCompleto(2)}>
                  Dar de alta paciente
                </button>
              </div>
              <button className="btnBlue comentarios-btn-agendar" onClick={() => checkComentarioCompleto(3)}>
                Guardar comentario | Agendar 4 citas
              </button>
            </div>
            <div className="card-section comentarios-timeline">
              <div className="comentarios-timeline-list">
                {comentarios && comentarios.length > 0 ? (
                  [...comentarios].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map((c, idx) => (
                    <div className="comentario-timeline-item" key={c.idComentario}>
                      <div className="comentario-timeline-dot" />
                      <div className="comentario-timeline-content compact">
                        <div className="comentario-timeline-header">
                          <span className="comentario-timeline-user"><FaUser style={{ marginRight: 6 }} />{c.nombre}</span>
                          <span className="comentario-timeline-date"><FaClock style={{ marginRight: 4 }} />{c.fecha}</span>
                        </div>
                        <div className="comentario-timeline-text">{c.comentario}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="comentarios-timeline-empty"><FaComment style={{ marginRight: 8 }} />No hay comentarios aún.</div>
                )}
              </div>
            </div>
          </>
        )}

        {/* CANCELAR */}
        {tab === 'cancelar' && (
          <div className="card-section cancel-section">
            <div className="cancel-list">
              {citasProgramadas && citasProgramadas.length > 0 ? (
                citasProgramadas.map((cita) => {
                  const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                  const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                  const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                  const diaSemana = diasSemana[fecha.getDay()];
                  return (
                    <div className="cancel-checkbox-row" key={cita.idTurno}>
                      <input
                        type="checkbox"
                        name="cita"
                        value={cita.idTurno}
                        checked={citasSeleccionadas.includes(cita.idTurno)}
                        onChange={handleCheckboxChange}
                        disabled={selecciones.todas}
                      />
                      <span>{diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                    </div>
                  );
                })
              ) : (
                <div>No hay próximas sesiones programadas.</div>
              )}
            </div>
            <button
              className="cancel-btn-fixed"
              onClick={() => {
                handleCancelar();
                setCitasSeleccionadas([]);
              }}
              disabled={isDisabled}
            >
              Cancelar seleccionadas
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TurnoModal;
